import { t } from 'i18next';
import { useContext } from 'react';

import {
  BulkActionsBar,
  BulkActionsBarCountButton,
} from '~components/BulkActionsBar/BulkActionsBar';

import { BILLING_LINE_SIDES, getLinesOfSide } from '../chargeSelection';
import ChargesSelectionContext, {
  ChargesSelectionActionsContext,
} from '../ChargesSelectionContext';
import ChargesSideActions from './ChargesSideActions';

export default function ChargesSelectionBar() {
  const { checkedLines } = useContext(ChargesSelectionContext);
  const { uncheckAllLines } = useContext(ChargesSelectionActionsContext);

  if (checkedLines.length === 0) {
    return null;
  }

  return (
    <BulkActionsBar>
      <BulkActionsBarCountButton onClick={uncheckAllLines}>
        {t('approvals.approve_charges.selection.lines_selected', {
          count: checkedLines.length,
        })}
      </BulkActionsBarCountButton>

      {BILLING_LINE_SIDES.map((side) => {
        const sideLines = getLinesOfSide(checkedLines, side);

        return sideLines.length > 0 ? (
          <ChargesSideActions key={side} lines={sideLines} side={side} />
        ) : null;
      })}
    </BulkActionsBar>
  );
}
